import ajaxRequest from 'utils/_ajax-request.js'

import { convertDateObject } from 'utils/_convert_date.js'

export default () => {

  if (window.jQuery) {
    $(document).ready(function(){

      const customerSelect = $('#customer-select')
      if( customerSelect.length ) {
        const customerSelectValue = customerSelect.data('value')
        customerSelect.select2({
          data: [],
        });

        ajaxRequest(
          (xhr, error) => {
            if( error ) {
              return false
            }
            const data = JSON.parse(xhr.response)
            customerSelect.select2('destroy').empty().select2({data: data.results});
            if( customerSelectValue ) {
              customerSelect.val(customerSelectValue)
            }
            else {
              customerSelect.val("")
            }
            customerSelect.trigger("change");
          },
          (customerSelect.data('source-data-url'))
        )
      }


      const designerSelect = $('#designer-select')
      if( designerSelect.length ) {
        const designerSelectValue = designerSelect.data('value')
        designerSelect.select2({
          data: [],
        });

        ajaxRequest(
          (xhr, error) => {
            if( error ) {
              return false
            }
            const data = JSON.parse(xhr.response)
            designerSelect.select2('destroy').empty().select2({data: data.results});
            if( designerSelectValue ) {
              designerSelect.val(designerSelectValue)
            }
            else {
              designerSelect.val("")
            }
            designerSelect.trigger("change");
          },
          (designerSelect.data('source-data-url'))
        )
      }

    })
  }


  let locale = 'en'
  if( document.documentElement.lang == 'ru' ) {
    locale = 'ru'
  }

  const periodFromElement = document.getElementById('order_filter_period_from')
  const periodToElement = document.getElementById('order_filter_period_to')

  if( window.flatpickr ) {
    if( periodFromElement ) {
      flatpickr(periodFromElement, {
        //defaultDate: (new Date( parseInt(periodFromElement.dataset.unixTimestamp, 10) * 1000)),
        defaultDate: convertDateObject(parseInt(periodFromElement.dataset.unixTimestamp, 10)),
        enableTime: false,
        enableSeconds: false,
        time_24hr: true,
        minuteIncrement: 1,
        dateFormat: 'Y-m-d',
        locale: locale,
      });
    }

    if( periodToElement ) {
      flatpickr(periodToElement, {
        //defaultDate: (new Date( parseInt(periodToElement.dataset.unixTimestamp, 10) * 1000)),
        defaultDate: convertDateObject(parseInt(periodToElement.dataset.unixTimestamp, 10)),
        enableTime: false,
        enableSeconds: false,
        time_24hr: true,
        minuteIncrement: 1,
        dateFormat: 'Y-m-d',
        locale: locale,
      });
    }
  }


}
